var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticStyle:{"z-index":"2222"},attrs:{"show":_vm.loading,"no-wrap":"","opacity":"0.5"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"d-flex justify-content-center w-100"},[_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }